import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { HeaderAdmin, DateSelector } from '../../../components/molecues';
import { Table } from '../../../../common/components/atoms';
import { Button, Select, LoadingView } from '../../../../common/components/atoms';
import { ModalDialog } from '../../../../common/components/molecues';

import { checkNull } from '../../../../common/helper/commonHelper.js'

import { Pagenation } from '../../../common/Pagenation.jsx';

class RecordCtrl extends Component {
    constructor(props) {
        super(props);

        this.Audio = React.createRef();
        this.Pagenation = new Pagenation();
        this.state = {
            currentDate: new Date(),
            course: "-1",
            searchText: "",
            recordData: [],
            displayDeleteCnf: false,
            deleteReady: -1,
            currentPage: 0,
            pageSeparation: 0,
            pagingList: [],

            loadedAudio: 0,
            loading: false,
        }
    }
    componentDidMount() {
        this.props.dispatch({
            type: "CheckMaintenance_Saga"
        });
        this.props.dispatch({
            type: "LoadEnd"
        });
    }

    onChangeCourse = (e) => {
        this.setState({ course: e.target.value });
    }

    onChangeSearch = (e) => {
        this.setState({
            searchText: e.target.value
        })
    }

    onClickColumn = (index) => {
    }
    onClickRow = (index) => {
    }

    onClickPlay = (index) => {
        let id = this.state.pagingList[index].id;
        let recordData = this.state.recordData;
        if(this.state.audioPlay) {
            for(let key in recordData) {
                if(id === recordData[key].id) {
                    recordData[key].play = 0;
                }
            }
            this.Audio.current.pause();
            this.setState({
                audioPlay: false,
                recordData: recordData,
            });
        } else {
            let src;
            for(let key in recordData) {
                if(id === recordData[key].id) {
                    recordData[key].play = 1;
                    src = recordData[key].audioData;
                }
            }
            this.Audio.current.src = src;
            this.Audio.current.load();
            this.Audio.current.play();
            this.setState({
                audioPlay: true,
                recordData: recordData,
            });
        }
    }

    createRecordData(records) {
        let recordData = [];
        for (let key in records) {
            recordData.push({
                id: records[key].id,
                userID: records[key].userID,
                address: records[key].address,
                course: checkNull(records[key].course) ? this.props.course[records[key].course].name : "",
                createDate: records[key].createDate,
                sendDatetime: records[key].sendDatetime,
                submitDate:records[key].sendDatetime?records[key].sendDatetime:records[key].createDate,
                audioData: records[key].audioData,
                disable: records[key].deleteFlg,
                play: 0,
            });
        }
        this.setState({ 
            recordData: recordData,
            pagingList: this.Pagenation.getList(recordData, this.state.currentPage)
        });
    }
    createTableProps() {
        const height = (window.innerHeight - 64 - 20 - 28 - 64) + "px";
        return {
            height: height,
            columns: {
                "ユーザーID": "userID",
                "メールアドレス": "address",
                "コース": "course",
                "送信日時": "submitDate",
            },
            data: this.state.pagingList,
            onClickColumn: this.onClickColumn,
            onClickRow: this.onClickRow,
            controls: {
                "play": {
                    onClick: this.onClickPlay,
                    control: "play",
                    contents: [
                        <TableContrl Color="#0077FF">
                            <i className="far fa-play-circle" />
                        </TableContrl>,
                        <TableContrl Color="#0077FF">
                            <i className="far fa-stop-circle" />
                        </TableContrl>
                    ],
                },
                "delete": {
                    onClick: this.onClickDelete,
                    contents: (
                        <TableContrl Color="#888888">
                            <i className="fas fa-trash" />
                        </TableContrl>
                    ),
                }
            }
        };
    }
    
    checkLoadEnded = (loadedAudio) => {
        if(loadedAudio < Object.keys(this.state.recordData).length) {
            return false;
        }
        return true;
    }

    onSuccessAudio = (audio, id) => {
        let audios = this.state.recordData;
        let loadedAudio = this.state.loadedAudio + 1;
        let check = this.checkLoadEnded(loadedAudio);
        audios[id].audioData = audio;
        this.setState({
            recordData: audios,
            loadedAudio: loadedAudio,
            loading: !check
        })
        if(check) {
            this.props.dispatch({
                type: "LoadEnd"
            });
    
            this.createRecordData(audios);
        }

    }
    onFailureAudio = (status, error) => {
        let loadedAudio = this.state.loadedAudio + 1;
        let check = this.checkLoadEnded(loadedAudio);
        this.setState({
            loadedAudio: loadedAudio,
            loading: !check
        })
        if(check) {
            this.props.dispatch({
                type: "LoadEnd"
            });
    
            this.createRecordData(this.state.recordData);
        }
    }

    onSuccess = (list) => {
        this.setState({
            recordData: list,
        })
        if(list.length === 0) {
            this.props.dispatch({
                type: "LoadEnd"
            });
        }
        for(let key in list) {
            if(list[key]) {
                this.props.dispatch({
                    type: "DownloadAudio_Saga",
                    id: key,
                    name: list[key].audio,
                    mode: 1,
                    onSuccess: this.onSuccessAudio,
                    onFailure: this.onFailureAudio,
                });
            }
        }
    }
    onFailure = (status, error) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
    }

    onClickSearch = (e) => {
        this.setState({
            loadedAudio: 0,
            loading: false,
            currentPage: 0,
        })
        this.props.dispatch({
            type: "LoadStart"
        });
        let date = this.state.currentDate;
        this.props.dispatch({
            type: "GetRecordList_Saga",
            search: this.state.searchText,
            month: date.getFullYear() + "-" + ('0' + (date.getMonth() + 1)).slice(-2),
            course: this.state.course,
            mode: 0,
            onSuccess: this.onSuccess,
            onFailure: this.onFailure,
        });
    }

    onCilckBack = (e) => {
        this.props.history.push('/admin/top');
    }

    
    onChanageDate = (date) => {
        this.setState({ currentDate: date });
    }

    getDisplayDate() {
        let arr = this.state.currentDate.toString().split(' ');

        return arr[1] + ' ' + arr[3];
    }
    
    onSuccessDelete = (index) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        let recordData = this.state.recordData;
        recordData[index].disable = true;
        this.setState({
            recordData: recordData
        });
        this.setState({ displayDeleteCnf: false });
    }

    onClickDelete = (index) => {
        this.setState({
            displayDeleteCnf: true,
            deleteReady: index,
        });
    }

    onClickDeleteCnf = () => {
        this.props.dispatch({
            type: "LoadStart"
        });
        let index = this.state.deleteReady;
        this.props.dispatch({
            type: 'DeleteRecord_Saga',
            id: this.state.recordData[index].id,
            index: index,
            onSuccess: this.onSuccessDelete,
            onFailure: this.onFailure,
        });
    }
    onClickNotDelete = () => {
        this.setState({ displayDeleteCnf: false });
    }

    createDeleteDlgProps() {
        let contents = (
            <div style={{padding: "10px 0"}}>
                <div style={{padding: "10px 0"}}>
                    確認
                </div>
                <div>
                    音声ファイルを削除します<br/>
                    よろしいですか？
                </div>
            </div>
        )
        return {
            display: this.state.displayDeleteCnf,
            contents: contents,
            controls: {
                'はい': {
                    Color: '#000',
                    onClick: this.onClickDeleteCnf,
                },
                'いいえ': {
                    Color: '#000',
                    onClick: this.onClickNotDelete,
                }
            }
        }
    }

    onClickPageIndex = (index) => {
        this.setState({ 
            currentPage: index,
            pagingList: this.Pagenation.getList(this.state.recordData, index),
        });
    }
    onChageSeparation = (index) => {
        this.setState({
            pageSeparation: index,
            pagingList: this.Pagenation.getList(this.state.recordData, this.state.pagingList),
        })
    }

    onEnded = () => {
        let recordData = this.state.recordData;
        for(let key in recordData) {
            recordData[key].play = 0;
        }
        this.setState({
            audioPlay: false,
            recordData: recordData
        });
    }

    render() {
        const width = window.innerWidth + "px";
        const height = (window.innerHeight - 64 - 20) + "px";
        const propsHeader = {
            title: "録音データ管理",
            history: this.props.history,
        }
        const propsTable = this.createTableProps();
        const propsDeleteDlg = this.createDeleteDlgProps();
        let course = [];
        course["-1"] = "利用コース";
        for(let key in this.props.course) {
            course[String(key)] = this.props.course[key].name;
        }
        return (
            <Body>
                <HeaderAdmin {...propsHeader}></HeaderAdmin>
                <Contents Width={width} Height={height}>
                    <Controls>
                        <ControlsChild>
                            <DateSelector onChange={this.onChanageDate} 
                                style={{
                                    border: "1px solid #888",
                                    borderRadius: "5px",
                                    width: "150px",
                                    marginLeft: "10px",
                                    padding: "2px 5px",
                                }}
                                Display={true}
                                />
                            <Select array={course} onChange={this.onChangeCourse} value={this.state.course} />
                            <Input>
                                <input type="text" name="search" value={this.state.searchText} placeholder="ユーザーID または メールアドレス"
                                    onChange={this.onChangeSearch}></input>
                            </Input>
                            <SearchButton onClick={this.onClickSearch}>
                                <i className="fas fa-search" />
                            </SearchButton>
                            {this.Pagenation.getSelector(this.onChageSeparation)}
                        </ControlsChild>
                        <ControlsChild>
                            <Button
                                Color="#888888"
                                Width="100px"
                                onClick={this.onCilckBack}
                                text="戻る" />
                        </ControlsChild>
                    </Controls>
                    <Results>
                        <Table {...propsTable} />
                    </Results>
                    <div>
                        {this.Pagenation.getPageIndex(this.state.recordData, this.state.currentPage, this.onClickPageIndex)}
                    </div>
                </Contents>
                <audio ref={this.Audio} onEnded={this.onEnded}/>
                <ModalDialog name="delete-dlg" {...propsDeleteDlg} />
                <LoadingView Display={this.props.loading} />
            </Body>
        )
    }
}

const mapStateToProps = store => {
    return {
        loading: store.loading.loading,
        course: store.setting.course,
    }
};

const connectedRecordCtrl = connect(mapStateToProps)(RecordCtrl);
export { connectedRecordCtrl as RecordCtrl };

const Body = styled.div`
    overflow-x: hidden;
`;
const Contents = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: column;
    height: ${props => (props.Height)};
    padding-top: 20px;
`;
const Controls = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;
const ControlsChild = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Input = styled.div`
    width: 320px;
    text-align: center;
    margin: 0 10px;
    input {
        width: 100%;
        padding: 4px 10px;
        border: 1px solid #888;
    }
`;
const SearchButton = styled.div`
    color: #888;
    margin-left: 20px;
    i {
        font-size: 18px;
    }
    cursor: pointer;
`;

const Results = styled.div`
    margin-top: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    padding-left: 10px;
    width: calc(100% - 10px);
    overflow-y: auto;
`;

const TableContrl = styled.div`
    cursor: pointer;
    padding: 0 2px;
    color: ${props => props.Color};
`;
